<template>
  <div class="page-comp-transfer">
    <jw-modal :visible="visible" @ok="recipientOk" @cancel="handleCancel" :ok-loading="loading" title-align="start" width="600px" class="recipient">
      <template #title> {{ title }}</template>
      <jw-form :model="form" label-align="left" class="recipient-form" ref="personForm" @submit="handleSubmit">
        <jw-form-item
          field="persons"
          class="recipient-form-item form-label-text"
          :rules="[
            { required: true, message: $t('请选择接收人员') },
            { maxLength: 1, message: $t('只能选择一个接收人') }
          ]"
          :validate-trigger="['blur', 'input', 'change']"
        >
          <template #label>
            <xl-label-text :value="$t('接收人')" :row="1" />
          </template>

          <fh-person className="recipient-form-item-value" position="bl" :item="form.recipient" @cb="getVal($event, form.persons, index)"> </fh-person>

          <!-- <xl-tree-member-modal :memberNumber="1" ref="xlTreeMember" :tree="tree" @cb="getVal($event, form.persons, index)" :depart="form.recipient?.departList" :user="form.recipient?.userList" :multipleDep="false">
            <jw-input-tag readonly v-model="form.persons" class="recipient-form-item-value" :max-tag-count="2" :placeholder="$t('请选择接收人员')" />
          </xl-tree-member-modal> -->
        </jw-form-item>
        <!-- 线索 -->
        <template v-if="type == 1">
          <jw-form-item field="cluePool" class="recipient-form-item form-label-text" :rules="{ required: true, message: $t('请选择接收线索池') }">
            <template #label>
              <xl-label-text :value="$t('接收线索池')" :row="1" />
            </template>
            <jw-select :trigger-props="{ updateAtScroll: true }" v-model="form.cluePool" :options="cluePoolList" :placeholder="$t('请选择接收线索池')" class="recipient-form-item-value"> </jw-select>
          </jw-form-item>
        </template>
        <jw-form-item field="transferCause" :rules="rules" :validate-trigger="['change', 'input', 'blur']" class="recipient-form-item form-label-text">
          <template #label>
            <xl-label-text :value="$t('转移原因')" :row="1" />
          </template>
          <jw-textarea
            v-model="form.transferCause"
            :placeholder="$t('请填写转移原因')"
            class="recipient-form-item-value"
            :auto-size="{
              minRows: 2,
              maxRows: 5
            }"
            :max-length="10000"
          />
        </jw-form-item>
        <template v-if="changeFlag">
          <jw-form-item field="relationBusinessIds" class="recipient-form-item form-label-text">
            <template #label>
              <xl-label-text :value="$t('变更其他负责人')" :row="1" />
              <jw-tooltip>
                <icon-question-circle size="20" />
                <template #content>
                  {{ $t('tips.changePerson3') }}
                </template>
              </jw-tooltip>
            </template>
            <div>
              <jw-checkbox :model-value="checkedAll" @change="handleChangeAll">{{ $t('全选') }} </jw-checkbox>
              <jw-checkbox-group v-model="form.relationBusinessIds" @change="handleChange" :options="type == 2 ? chargePersonModules : chargePersonModules2">
                <template #label="{ data }">
                  <jw-tag>{{ $t(data.label) }}</jw-tag>
                </template>
              </jw-checkbox-group>
            </div>
          </jw-form-item>
        </template>
        <template v-if="n !== 'transferAll'">
          <jw-checkbox v-model="form.addOldOwnerToCollaborator">{{ $t('设置原负责人为协作人') }}</jw-checkbox>
        </template>
      </jw-form>
    </jw-modal>
  </div>
</template>

<script>
import { reactive, toRefs, computed, ref } from 'vue';
import { Message } from '@arco-design/web-vue';
import { publicService, leadsService, customService, setService } from '@/api/';
import { useI18n } from 'vue-i18n';
import { confine } from '@/utils/const';
export default {
  name: 'XlTransfer',
  props: {
    type: {
      type: Number
    }
  },
  setup(props, ctx) {
    const { t } = useI18n();
    console.log('1-开始创建组件-setup', props.searchV, ctx);
    const personForm = ref();
    const n = ref(''); //离职数据全部转移使用
    const type = computed(() => props?.type);
    // const getCluePool = async () => {
    //
    // }
    const getRuleObjList = async () => {
      try {
        const res = await setService.getRuleObjList({});
        const _c = [];
        const _o = [];
        if (!res.error) {
          res.result.map((v) => {
            if ([6, 8, 10].includes(v.value)) {
              _c.push(v);
              _o.push(v);
            }
            if ([3, 12].includes(v.value)) {
              _c.push(v);
            }
          });
        }
        data.chargePersonModules = _c;
        data.chargePersonModules2 = _o;
      } catch (e) {
        console.log(e);
      }
    };
    const rules = {
      required: true,
      validator: (value, cb) => {
        if (value) {
          if (value?.length >= confine.number20000) {
            cb(`录入字符数已达上限${confine.number20000}位，请检查`);
          }
        } else {
          cb(`请填写转移原因`);
        }
      }
    };

    const transferShow = async (record, val) => {
      getRuleObjList();
      n.value = val;
      data.form.recipient.departList = [];
      data.form.recipient.userList = [];
      data.form.addOldOwnerToCollaborator = false;
      data.checkedAll = false;
      data.visible = true;
      data.id = record.ids;
      data.title = record.title;
      data.conditions = record?.searchV; //用于全部转移
      data.userIds = record?.userIds;
      data.changeFlag = record.changeFlag; //是否显示变更为其他负责人
      data.form.relationBusinessIds = record.changeFlag ? (type.value == 2 ? data.chargePersonModules.map((v) => v.value) : data.chargePersonModules2.map((v) => v.value)) : [];
      data.checkedAll = !!record.changeFlag;
      personForm.value?.resetFields();
    };
    const data = reactive({
      visible: false,
      id: [],
      title: [],
      changeFlag: false,
      loading: false,
      checkedAll: false,
      cluePoolList: [],
      form: {
        recipient: {},
        persons: [],
        transferCause: '',
        cluePool: '',
        relationBusinessIds: [], //转移其他负责人
        addOldOwnerToCollaborator: false
      },
      chargePersonModules: [
        { value: 3, label: '商机' },
        { value: 6, label: '报价单' },
        { value: 8, label: '销售合同' },
        { value: 10, label: '销售订单' },
        { value: 12, label: '售后服务' }
      ],
      chargePersonModules2: [
        { value: 6, label: '报价单' },
        { value: 8, label: '销售合同' },
        { value: 10, label: '销售订单' }
      ],
      conditions: [],
      userIds: []
    });
    // 取消按钮
    const handleCancel = () => {
      data.visible = false;
    };
    // 左侧列表选择激活态结束
    const tree = ref({
      checkDepartment: false,
      isAll: true
    });
    //获取转移人所属线索池
    const getClueByUser = async (userList) => {
      data.cluePoolList = [];
      if (userList.length == 0) {
        return false;
      }

      try {
        const res = await leadsService.getClueByUser({ userId: userList[0]?.id });
        if (!res.error) {
          data.cluePoolList = res.result;
        }
      } catch (err) {
        console.log('获取转移人所属线索池失败', err);
      }
    };
    // 添加人员角色--获取部门或者用户的值
    const getVal = (v, index) => {
      if (type.value == 1) {
        //如果是线索转移获取线索池
        getClueByUser(v?.userList);
      }
      // prop为field值，单一清除时使用
      console.log('人员选择查看:', v, index, data.form.customForm);
      // 选择人员后，调添加人员接口，参数都在v中，按需去V中取
      const userNames = computed(() => v?.userList?.map((u) => u.userName));
      console.log('userNames', userNames.value);
      if (userNames.value) {
        personForm.value?.clearValidate();
      }
      data.form.persons = userNames.value;
      data.form.recipient = v;
      console.log('人员选择', data.form.recipient);
    };
    // 转移接口N
    const updateFollowUser = async () => {
      data.loading = true;
      try {
        const params = {
          type: type.value,
          businessIds: data.id,
          userId: data.form?.recipient?.userList[0]?.id,
          reason: data.form.transferCause,
          cluePoolId: type.value == 1 ? data.form.cluePool : '',
          relationBusinessIds: data.form.relationBusinessIds,
          addOldOwnerToCollaborator: data.form.addOldOwnerToCollaborator
        };
        // if(data.changeFlag){ params.relationBusinessIds=data.relationBusinessIds }
        if (n.value === 'transferAll') {
          console.log('全部转移逻辑');
          params.conditions = data.conditions.conditions;
          params.userIds = data.userIds;
          params.id = type.value || props?.type;
          const json = await publicService.updateFollowUserAll(params);
          if (!json.error) {
            Message.success(t('操作成功'));
            ctx.emit('cb');
          } else {
            Message.error(json.error?.msg || t('操作失败'));
          }
        } else {
          console.log(88, params);
          let url;
          if (params.type >= 200) {
            params['entity'] = params.type;
            url = customService.transferCustomData(params);
          } else {
            url = publicService.updateFollowUser(params);
          }
          const json = await url;
          if (!json.error) {
            Message.success(t('操作成功'));
            ctx.emit('cb');
          } else {
            Message.error(json.error?.msg || t('操作失败'));
          }
        }
        data.loading = false;
        handleCancel();
      } catch (e) {
        data.loading = false;
        Message.error(e.message || e.statusText || t('操作失败'));
      }
    };
    // 转移接口N
    const handleSubmit = ({ values, errors }) => {
      console.log('转移接口', values, errors);
      if (errors) {
        const errorArray = {};
        Object.values(errors).forEach((key, index) => {
          errorArray[key.field] = { status: 'error', message: '' };
          Object.values(errorArray).forEach((i, ind) => {
            if (index === ind) {
              i.message = key.message;
            }
          });
        });
        personForm.value.setFields(errorArray);
        // data.visible = true;
        return;
      }
      console.log('012345678');
      updateFollowUser();
    };
    const recipientOk = () => {
      personForm.value.handleSubmit();
    };
    const handleChangeAll = (value) => {
      if (value) {
        data.checkedAll = true;
        if (type.value == 2) {
          //客户
          data.form.relationBusinessIds = data.chargePersonModules.map((item) => item.value);
        } else {
          //商机
          data.form.relationBusinessIds = data.chargePersonModules2.map((item) => item.value);
        }
      } else {
        data.checkedAll = false;
        data.form.relationBusinessIds = [];
      }
    };

    const handleChange = (values) => {
      data.form.relationBusinessIds = values;
      console.log(values);
      if ((type.value == 2 && values.length === 5) || (type.value == 3 && values.length === 3)) {
        data.checkedAll = true;
      } else if (values.length === 0) {
        data.checkedAll = false;
      } else {
        data.checkedAll = false;
      }
    };
    return {
      n,
      tree,
      transferShow,
      getVal,
      personForm,
      handleSubmit,
      recipientOk,
      handleChangeAll,
      handleChange,
      handleCancel,
      rules,
      confine,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './xl-transfer.less';
</style>
